export default __webpack_public_path__ + "static/media/L&T 006 B rev.22d38359.jpg";